import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { IChart } from "../../../../../@types/chart.type";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { getCompanyCapacitySummary } from "../../../../../services/api/widgets/widgetsService";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { storageUserGet } from "../../../../../storage/storageUser";
import { ICapacitySummary } from "../../../../../@types/widgets.type";
import { IconHoursAllocationSummary } from "../../../../../icons/IconHoursAllocationSummary";
import styles from "./styles.module.scss";

interface CompanyTimeAllocationSummaryProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

export function CompanyTimeAllocationSummary({
  chart,
  deleteChart,
  ismodeEdit,
  rowHeightGrid,
}: CompanyTimeAllocationSummaryProps) {
  const [data, setData] = useState<ICapacitySummary>({} as ICapacitySummary);
  const [loading, setLoading] = useState(true);

  const user = storageUserGet();

  useEffect(() => {
    async function fetchCompanyCapacitySummary() {
      try {
        setLoading(true);
        const response = (await getCompanyCapacitySummary(
          user.email,
          user?.resourceId as string
        )) as IApiResponse<ICapacitySummary>;

        if (response.statusCode === 200) {
          setData(response.result);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchCompanyCapacitySummary();
  }, [user.email, user?.resourceId]);

  const {
    totalCapacity,
    totalHoursBillable,
    totalHoursNonBillable,
    totalIdleHours,
  } = data;

  const series = [totalHoursBillable, totalHoursNonBillable, totalIdleHours];

  const labels = [
    "Total de horas faturadas",
    "Total de horas não faturadas",
    "Ociosidade",
  ];

  const options = {
    chart: {
      type: "donut",
      width: "100%",
      height: { rowHeightGrid },
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    labels,
    legend: {
      show: true,
      labels: {
        colors: "#616161",
        useSeriesColors: false,
      },
      fontSize: "14px",
      fontFamily: "Archivo, sans-serif",
      fontWeight: 400,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: false,
              fontFamily: "Archivo",
              fontWeight: 600,
              color: "#616161",
              fontSize: "16px",
            },
            value: {
              show: true,
              fontFamily: "Archivo",
              fontWeight: 500,
              color: "#616161",
              fontSize: "16px",
              formatter: (val: string) => {
                const numVal = Math.floor(parseFloat(val));
                return `${numVal}h`;
              },
            },
            total: {
              show: true,
              label: "Total",
              fontFamily: "Archivo",
              fontWeight: 700,
              fontSize: "16px",
              color: "#212121",
              formatter: function () {
                return `${Math.floor(totalCapacity)}h`;
              },
            },
          },
        },
      },
    },
    colors: ["#5BC763", "#FFEC3F", "#FD9595", "#97CBF3"],
    dataLabels: {
      enabled: true,
      style: {
        fontFamily: "Archivo, sans-serif",
        fontWeight: "600",
        colors: ["#212121"],
      },
      formatter: function (val: number) {
        return `${val.toFixed(0)}%`;
      },
      dropShadow: {
        enabled: false,
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex }) {
        const value = series[seriesIndex];
        const label = labels[seriesIndex];

        return `
          <div class='labelCustom' style="flex-direction: row;">
            <strong>${label}:</strong>
            <span>${Math.floor(value)}h</span>
          </div>
        `;
      },
    },
  };

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <IconHoursAllocationSummary size={30} />
          Resumo de Horas Alocadas da Empresa
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        {loading ? (
          <p style={{ textAlign: "center", color: "#212121" }}>Carregando...</p>
        ) : (
          <>
            {data ? (
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                width="100%"
                height={rowHeightGrid - 50}
              />
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "2rem",
                  color: "#616161",
                }}
              >
                <p style={{ marginTop: "1rem" }}>Nenhum dado encontrado.</p>
              </div>
            )}
          </>
        )}
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
